/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from './AdditionalInfo.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

export type TypeProps = {|
  // eslint-disable-line flow-prefer-exact-object-types
  title: string,
  details: any,
|};

function AdditionalInfo(props: TypeProps): React.Element<*> {
  const { title, details, t }: TypeProps = props;
  const noinfo: string = t('general:messages.no_additional_info', { title: `$t(${title})` });

  const createMarkup: Function = () => {
    return { __html: details.additional_info || noinfo };
  };

  return (
    <div className={`${styles['additional-info']}`}>
      <h3>{t('general:additional_info', { title: `$t(${title})` })}</h3>
      <div dangerouslySetInnerHTML={createMarkup()} />
    </div>
  );
}

export default translate()(AdditionalInfo);
